import styled from 'styled-components';
import { ReactComponent as Close } from './close.svg';

const Container = styled.section`
  position: fixed;
  top: 0;

  width: 100vw;
  height: 60px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  row-gap: 8px;
  flex-direction: column;

  padding: 14px;
  z-index: 10000;

  background: #2d9cdb;
`;

const P = styled.p`
  color: white;
  font-size: 10px;
  margin-right: 50px;
`;

const H = styled(P)`
  font-weight: 900;
`;

const CloseIcon = styled(Close)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;

  cursor: pointer;
`;

export const S = {
  Container,
  P,
  H,
  CloseIcon,
};
